"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function transformStream(readable, transformer, oncancel) {
    try {
        return readable.pipeThrough(new TransformStream(transformer));
    }
    catch (e) {
        var reader_1 = readable.getReader();
        return new ReadableStream({
            start: function (controller) {
                if (transformer.start) {
                    return transformer.start(controller);
                }
            },
            pull: function (controller) {
                return __awaiter(this, void 0, void 0, function () {
                    var enqueued, wrappedController, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                enqueued = false;
                                wrappedController = {
                                    enqueue: function (d) {
                                        enqueued = true;
                                        controller.enqueue(d);
                                    }
                                };
                                _a.label = 1;
                            case 1:
                                if (!!enqueued) return [3, 7];
                                return [4, reader_1.read()];
                            case 2:
                                data = _a.sent();
                                if (!data.done) return [3, 5];
                                if (!transformer.flush) return [3, 4];
                                return [4, transformer.flush(controller)];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2, controller.close()];
                            case 5: return [4, transformer.transform(data.value, wrappedController)];
                            case 6:
                                _a.sent();
                                return [3, 1];
                            case 7: return [2];
                        }
                    });
                });
            },
            cancel: function (reason) {
                readable.cancel(reason);
                if (oncancel) {
                    oncancel(reason);
                }
            }
        });
    }
}
exports.transformStream = transformStream;
var BlobStreamController = (function () {
    function BlobStreamController(blob, size) {
        this.blob = blob;
        this.index = 0;
        this.chunkSize = size || 1024 * 64;
    }
    BlobStreamController.prototype.pull = function (controller) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var bytesLeft = _this.blob.size - _this.index;
            if (bytesLeft <= 0) {
                controller.close();
                return resolve();
            }
            var size = Math.min(_this.chunkSize, bytesLeft);
            var slice = _this.blob.slice(_this.index, _this.index + size);
            var reader = new FileReader();
            reader.onload = function () {
                controller.enqueue(new Uint8Array(reader.result));
                resolve();
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(slice);
            _this.index += size;
        });
    };
    return BlobStreamController;
}());
function blobStream(blob, size) {
    return new ReadableStream(new BlobStreamController(blob, size));
}
exports.blobStream = blobStream;
var ConcatStreamController = (function () {
    function ConcatStreamController(streams) {
        this.streams = streams;
        this.index = 0;
        this.reader = null;
        this.nextReader();
    }
    ConcatStreamController.prototype.nextReader = function () {
        var next = this.streams[this.index++];
        this.reader = next && next.getReader();
    };
    ConcatStreamController.prototype.pull = function (controller) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.reader) {
                            return [2, controller.close()];
                        }
                        return [4, this.reader.read()];
                    case 1:
                        data = _a.sent();
                        if (data.done) {
                            this.nextReader();
                            return [2, this.pull(controller)];
                        }
                        controller.enqueue(data.value);
                        return [2];
                }
            });
        });
    };
    return ConcatStreamController;
}());
function concatStream(streams) {
    return new ReadableStream(new ConcatStreamController(streams));
}
exports.concatStream = concatStream;
//# sourceMappingURL=streams.js.map